import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPersonalInfo } from '../utils/contentLoader';

function NotFound() {
  const personalInfo = getPersonalInfo();
  
  useEffect(() => {
    // Set page title
    document.title = `${personalInfo.name || 'Personal Website'} - Page Not Found`;
    
    return () => {
      // Reset title when component unmounts
      document.title = personalInfo.name || 'Personal Website';
    };
  }, [personalInfo.name]);
  
  return (
    <div className="not-found-page">
      <div className="container">
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
        <Link to="/" className="home-link">Return to Home</Link>
      </div>
    </div>
  );
}

export default NotFound;